exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".geo-element[data-v-b1683102]{text-decoration:none;color:#000;display:flex;flex-direction:column;padding:6px;font-size:18px}.geo-element img[data-v-b1683102]{margin-top:12px}", ""]);

// exports
